import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-fb417436")

_pushScopeId("data-v-fb417436")
const _hoisted_1 = { class: "shoppinglist-recommendation-list-item" }
const _hoisted_2 = { class: "shoppinglist-recommendation-list-item-card-image" }
const _hoisted_3 = {
  key: 1,
  class: "shoppinglist-recommendation-list-item-card-image-image",
  src: _imports_0
}
const _hoisted_4 = { class: "shoppinglist-recommendation-list-item-card-content" }
const _hoisted_5 = { class: "shoppinglist-recommendation-list-item-card-content-title" }
const _hoisted_6 = { class: "shoppinglist-recommendation-list-item-card-content-title-text" }
const _hoisted_7 = { class: "shoppinglist-recommendation-list-item-card-content-description" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "shoppinglist-recommendation-list-item-card",
      onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.touchStart(...args))),
      onTouchmove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.touchMove(...args))),
      onTouchend: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.touchEnd(...args))),
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clickFood(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        (_ctx.imageUrl)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "shoppinglist-recommendation-list-item-card-image-image",
              src: _ctx.imageUrl,
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args))),
              onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.imageTouchStart(...args))),
              onTouchmove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.imageTouchMove(...args))),
              onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.imageTouchEnd(...args)))
            }, null, 40, ["src"]))
          : (_openBlock(), _createBlock("img", _hoisted_3))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", {
            innerHTML: _ctx.descriptionText,
            class: "shoppinglist-recommendation-list-item-card-content-description-text"
          }, null, 8, ["innerHTML"])
        ])
      ])
    ], 32)
  ]))
})